import { render, staticRenderFns } from "./PlumbingCAD.vue?vue&type=template&id=2266cef5&scoped=true"
import script from "./PlumbingCAD.vue?vue&type=script&lang=js"
export * from "./PlumbingCAD.vue?vue&type=script&lang=js"
import style0 from "./PlumbingCAD.vue?vue&type=style&index=0&id=2266cef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266cef5",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QBtn});
